const $ = jQuery

export default function startAnimations () {
  const sectionsArray = ['.mtt-ttmzero-circle', '.mtt-ttmzero-ppt__svg']

  for (let i = 0; i < sectionsArray.length; i++) {
    const sections = document.querySelectorAll(sectionsArray[i])

    if (sections.length) {
      for (let j = 0; j < sections.length; j++) {
        const section = sections[j]

        if (section) {
          addAnimationClass(section)

          window.addEventListener('scroll', () => {
            addAnimationClass(section)
          })
        }
      }
    }
  }
} 

function addAnimationClass (section) {
  if (inViewport(section)) {
    if (!section.classList.contains('start-animation')) {
      section.classList.add('start-animation')
    }
  }
}

function inViewport (el) {
  if (!el) return false

  const BOUNDING = el.getBoundingClientRect()

  if (
    BOUNDING.top > 0 && BOUNDING.top <= (window.innerHeight || document.documentElement.clientHeight) || // when top of el is in viewport
    BOUNDING.bottom > 0 && BOUNDING.bottom <= (window.innerHeight || document.documentElement.clientHeight) // when bottom of el is in viewport
  ) {
    return true
  }

  return false
}
